/**
 * src/components/agent/AttachMenu.jsx
 *
 * Phase 82-04 — Chat System Unification, composer attachment menu.
 *
 * Lightweight dropdown with three actions:
 *   - File           — triggers the hidden file input
 *   - Photo / camera — same input with capture hint (mobile)
 *   - Voice memo     — engages legacy mic recording (for now)
 *
 * Stateless — parent owns the open flag + handlers.
 */

import { Paperclip, Camera, Mic } from 'lucide-react';
import { attachMenuStyle, attachItemStyle } from './ChatComposerV2.styles';

export default function AttachMenu({
  open,
  onSelectFile,
  onSelectPhoto,
  onSelectVoice,
}) {
  if (!open) return null;
  return (
    <div
      role="menu"
      aria-label="Attach"
      data-testid="attach-menu"
      style={attachMenuStyle}
    >
      <button
        type="button"
        role="menuitem"
        style={attachItemStyle}
        onMouseDown={(e) => { e.preventDefault(); onSelectFile?.(); }}
        data-testid="attach-menu-file"
      >
        <Paperclip size={16} strokeWidth={2} color="var(--tm)" />
        <span>File</span>
      </button>
      <button
        type="button"
        role="menuitem"
        style={attachItemStyle}
        onMouseDown={(e) => { e.preventDefault(); onSelectPhoto?.(); }}
        data-testid="attach-menu-photo"
      >
        <Camera size={16} strokeWidth={2} color="var(--tm)" />
        <span>Photo</span>
      </button>
      {onSelectVoice && (
        <button
          type="button"
          role="menuitem"
          style={attachItemStyle}
          onMouseDown={(e) => { e.preventDefault(); onSelectVoice(); }}
          data-testid="attach-menu-voice"
        >
          <Mic size={16} strokeWidth={2} color="var(--tm)" />
          <span>Voice memo</span>
        </button>
      )}
    </div>
  );
}
